<template>
    <div class="nevs-content">
        <div class="validity-info">
            {{ $LANG.Get('labels.validUntil') }} {{ client.valid_until_display }}
        </div>
        <NevsCard>
            <table class="subscription-table" v-if="invoices.length > 0">
                <thead>
                    <tr>
                        <th>{{ $LANG.Get('fields.number') }}</th>
                        <th>{{ $LANG.Get('fields.dateOfIssue') }}</th>
                        <th>{{ $LANG.Get('labels.amount') }}</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="invoice in invoices" :key="invoice.id">
                        <td>{{ invoice.number }}</td>
                        <td>{{ invoice.date_of_issue }}</td>
                        <td>{{ invoice.amount }}</td>
                        <td class="pdf-cell">
                            <NevsButton @click="pdfClick(invoice.id)">
                                <i class="fa-solid fa-file-pdf"></i>
                                {{ $LANG.Get('tooltips.pdf') }}
                            </NevsButton>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div v-else class="no-invoices">{{ $LANG.Get('labels.noSubscriptionInvoices') }}</div>
        </NevsCard>
    </div>
</template>

<script>
import NevsCard from "@/components/nevs/NevsCard.vue";
import NevsButton from "@/components/nevs/NevsButton.vue";
import Client from "@/models/Client.js";

export default {
    name: "ModuleSubscription",
    components: {NevsCard, NevsButton},
    data() {
        return {
            client: new Client(),
            invoices: []
        }
    },
    methods: {
        pdfClick(id) {
            let vm = this;
            this.$API.APICall('get', 'subscription/invoices/pdf/' + id, {}, (data, success) => {
                if (success) {
                    const bytes = atob(data.pdf_base64);
                    const arr = new Uint8Array(bytes.length);
                    for (let i = 0; i < bytes.length; i++) arr[i] = bytes.charCodeAt(i);
                    const blob = new Blob([arr], {type: 'application/pdf'});
                    const url = URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = data.pdf_filename || 'racun.pdf';
                    a.click();
                    URL.revokeObjectURL(url);
                } else {
                    vm.$HELPERS.HandleServerError(vm, data);
                }
            });
        },
        loadInvoices() {
            let vm = this;
            this.$API.APICall('get', 'subscription/invoices', {}, (data, success) => {
                if (success) {
                    vm.invoices = data.invoices;
                } else {
                    vm.$HELPERS.HandleServerError(vm, data);
                }
            });
        }
    },
    mounted() {
        this.$store.commit('selectMenu', 'subscription');
        this.$store.commit('selectSubMenu', null);
        this.$store.commit('setBreadcrumbs', [
            {
                label: this.$LANG.Get('modules.subscription'),
                link: null
            }
        ]);
        let vm = this;
        this.$API.APICall('get', 'client', {}, (data, success) => {
            if (success && data.client !== null) {
                vm.client.Fill(data.client);
            }
        });
        this.loadInvoices();
    }
}
</script>

<style scoped lang="scss">
@use '../../scss/vars' as *;

.validity-info {
    margin-top: 10px;
    margin-bottom: 10px;
    background: white;
    border-radius: 5px;
    padding: 10px 15px;
    box-shadow: 0 0 50px 0 rgba(82, 63, 105, 0.15);
    border-left: 4px solid $primary;
    font-size: 14px;
    color: $font-color;
}

.subscription-table {
    width: 100%;
    border-collapse: collapse;
}

.subscription-table th,
.subscription-table td {
    padding: 8px 12px;
    text-align: left;
    border-bottom: 1px solid #e0e0e0;
}

.subscription-table th {
    font-weight: 600;
    background-color: #f5f5f5;
}

.pdf-cell {
    text-align: right;
    white-space: nowrap;
}

.no-invoices {
    padding: 16px;
    color: $muted-text;
}
</style>
